import homepageTags from './tags/homepage';
import housingTags from './tags/housing';
import sustainabilityTags from './tags/sustainability';
import base from './tags/base';
import articlesTags from './tags/articles';


import baseESTags from './tags/es/base';
import homepageESTags from './tags/es/homepage';
import housingESTags from './tags/es/housing';

import mapTags from './tags/map';

export function fireTag(tag, text) {
    if(window.location.href.includes('/map/') && !tag.includes('G') && !tag.includes('footer')){
        if(tag.includes('C1')){
            let temp = mapTags[tag];
            temp['clickText'] = text;
            window.dataLayer.push(temp);
        } else if(tag.includes('C2')){
            let temp = mapTags[tag];
            temp['clickText'] = `state selector: ${text}`;
            window.dataLayer.push(temp);
        } else if(tag.includes('C3')){
            let temp = mapTags[tag];
            temp['clickText'] = `district selector: ${text}`;
            window.dataLayer.push(temp);
        } else if(tag.includes('C4')){
            let temp = mapTags[tag];
            temp['clickText'] = `issue selector: ${text}`;
            window.dataLayer.push(temp);
        } else if(tag.includes('C5')){
            let temp = mapTags[tag];
            temp['clickText'] = `pagination: ${text}`;
            window.dataLayer.push(temp);
        } else {
            window.dataLayer.push(mapTags[tag]);
        }
    } else if(window.location.href.includes('/sustainability/') && !tag.includes('G') && !tag.includes('footer')){
    if(tag.includes('C1')  || tag.includes('C2') ||
        tag.includes('C3') || tag.includes('C4') ||
        tag.includes('C5') || tag.includes('C6') ||
        tag.includes('C7') || tag.includes('C8')
     ){
        let temp = sustainabilityTags[tag];
        temp['clickText'] = text;
        window.dataLayer.push(temp);
    } else if(tag.includes('A1') || tag.includes('A2')){
        let temp = articlesTags[tag];
        temp['clickText'] = text;
        window.dataLayer.push(temp);
    } else {
        window.dataLayer.push(sustainabilityTags[tag]);
    }
} else if(window.location.href.includes('/housing/') && !tag.includes('G') && !tag.includes('footer')){
    if(tag.includes("C2") || tag.includes("C3")){
        let temp = '';
        if(window.location.href.includes('/es/')){
            temp = housingESTags[tag];
        } else {
            temp = housingTags[tag];
        }
        temp['clickText'] = text;
        window.dataLayer.push(temp);
    }else {
        if(window.location.href.includes('/es/')){
            window.dataLayer.push(housingESTags[tag]);
        } else {
            window.dataLayer.push(housingTags[tag]);
        }
    }
} else {
    if(tag.includes('G') || tag.includes('footer')
    || tag.includes('hamburger')
    ){
        if(window.location.href.includes('/es/')){
            window.dataLayer.push(baseESTags[tag]);
        } else {
            window.dataLayer.push(base[tag]);
        }
    }
    else if(tag == 'C5'){
        let temp = '';
        if(window.location.href.includes('/es/')){
            temp = homepageESTags[tag];
        } else {
            temp = homepageTags[tag];
        }
        temp['siteSection'] = text;
        window.dataLayer.push(temp);
    }
    else if(text !== undefined){
        let temp = '';
        if(window.location.href.includes('/es/')){
            temp = homepageESTags[tag];
        } else {
            temp = homepageTags[tag];
        }
        temp = homepageTags[tag];
        temp['clickText'] = text;
        window.dataLayer.push(temp);

    } else {
        if(window.location.href.includes('/es/')){
            window.dataLayer.push(homepageESTags[tag]);
        } else {
            window.dataLayer.push(homepageTags[tag]);
        }
    }
}
};